var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.7 18.111a10.805 10.805 0 000-4.222l2.403-1.978a.728.728 0 00.168-.925l-2.293-3.972a.727.727 0 00-.885-.317L23.17 7.792a10.881 10.881 0 00-3.647-2.109l-.513-3.075A.727.727 0 0018.293 2h-4.586a.727.727 0 00-.717.608l-.513 3.075A10.884 10.884 0 008.83 7.792L5.907 6.697a.727.727 0 00-.885.317L2.73 10.986a.727.727 0 00.168.925L5.3 13.889a10.805 10.805 0 000 4.222L2.897 20.09a.727.727 0 00-.168.925l2.293 3.972a.727.727 0 00.885.317l2.923-1.095a10.885 10.885 0 003.647 2.109l.513 3.075a.727.727 0 00.717.608h4.586a.727.727 0 00.717-.608l.513-3.076a10.883 10.883 0 003.647-2.108l2.923 1.095a.727.727 0 00.885-.317l2.293-3.972a.727.727 0 00-.168-.925zM16 21.631A5.632 5.632 0 1121.632 16 5.638 5.638 0 0116 21.632z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--cog-wheel-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'CogWheelIcon';
export default Icon;